import { AppIcon } from "~/components/app-icon";
import { useRovingTablist } from "~/hooks/use-roving-tablist";
import {
  getTaskArea,
  TASK_KEYS,
  type TaskKey,
  type WorkbenchTask,
} from "~/lib/constants/workbench";
import * as m from "~/paraglide/messages.js";

interface TaskTablistProps {
  onSelect: (key: TaskKey) => void;
  panelId: string;
  selected: TaskKey;
  tasks: Record<TaskKey, WorkbenchTask>;
}

export function TaskTablist({
  onSelect,
  panelId,
  selected,
  tasks,
}: Readonly<TaskTablistProps>) {
  const onKeyDown = useRovingTablist(TASK_KEYS, selected, onSelect);

  return (
    <aside className="task-sidebar">
      <p>{m.home_bench_sidebar_title()}</p>

      <div
        aria-label={m.home_bench_tablist_label()}
        aria-orientation="vertical"
        className="task-tabs"
        role="tablist"
      >
        {TASK_KEYS.map((key) => {
          const task = tasks[key];
          const isActive = key === selected;
          return (
            <button
              aria-controls={panelId}
              aria-selected={isActive}
              id={`tab-${key}`}
              key={key}
              onClick={() => onSelect(key)}
              onKeyDown={onKeyDown}
              role="tab"
              tabIndex={isActive ? 0 : -1}
              type="button"
            >
              <AppIcon name={task.icon} />
              <span>
                {task.label}
                <small>{getTaskArea(key)}</small>
              </span>
            </button>
          );
        })}
      </div>

      <div className="sidebar-note">
        <span aria-hidden="true">↳</span>
        {m.home_bench_sidebar_note_1()} <br />
        {m.home_bench_sidebar_note_2()}
      </div>
    </aside>
  );
}
